module.exports = __webpack_public_path__ + "img/how_to_print_edge_cn.a0942036.png";